import { RecurringPaymentType } from '@finxone-platform/shared/sys-config-types';
import {
  PispCancelRecurringPaymentRequest,
  RecurringPaymentsRequest,
} from '../services/recurring-payments-service/recurring-payments.service';

export class GetRecurringPayments {
  static readonly type = '[RecurringPayments] GetRecurringPayments';
  constructor(public params: RecurringPaymentsRequest) {}
}

export class ClearRecurringPayments {
  static readonly type = '[RecurringPayments] ClearRecurringPayments';
}

export class SetCurrentRecurringPayment {
  static readonly type = '[RecurringPayments] SetCurrentRecurringPayment';
  constructor(public recurringPayment: RecurringPaymentType) {}
}

export class PispCancelRecurringPayment {
  static readonly type = '[RecurringPayments] PispCancelRecurringPayment';
  constructor(public params: PispCancelRecurringPaymentRequest) {}
}
